export const primary_color_1 = "#49a3f1";
export const primary_color_2 = "#123f75";
export const primary_gradient = `linear-gradient(45deg, ${primary_color_1}, ${primary_color_2})`;
export const primary_gradient_reverse = `linear-gradient(45deg, ${primary_color_2}, ${primary_color_1})`;
